<template>
  <div class="block block_wide">
    <div class="event-contacts-card">
      <Avatar
        :img="themeImages['support-avatar']"
        :size="64"
      >
      </Avatar>
      <div class="event-contacts-card__phone text-lg" v-if="phoneNumber">
        <b>{{ phoneNumber }}</b>
      </div>
      <div class="text-sm">{{ $t('contacts.eventSupport') }}</div>
      <Button
        class="event-contacts-card__button"
        v-open-modal="{ name: 'contacts-modal' }"
        v-bind="{
         variant: 'secondary',
         text: $t('contacts.contact'),
         iconRight: 'right',
         ...buttonProps,
        }"
      ></Button>
    </div>
    <Modal
      name="contacts-modal"
      align="center"
      ref="modal"
    >
      <div class="base-modal__heading base-modal__item">
        <div class="base-modal__top-img">
          <img :src="themeImages['questions']" width="322" alt="">
        </div>
        <h3 class="base-modal__title">{{ $t('contactModal.title') }}</h3>
        <div class="base-modal__subtitle">{{ $t('contactModal.subtitle') }}</div>
      </div>
      <div class="base-modal__body base-modal__item">
        <div class="text-content html-content" v-html="content"></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'ContactsBlock',
  props: {
    content: String,
    buttonProps: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Modal,
    Avatar,
  },
  computed: {
    ...mapGetters('settings', ['themeImages']),
    phoneNumber() {
      if (!this.content) {
        return null;
      }
      const regexp = '(\\+7|8)[- _]*\\(?[- _]*(\\d{3}[- _]*\\)?([- _]*\\d){7}|\\d\\d[- _]*\\d\\d[- _]*\\)?([- _]*\\d){6})';
      const match = this.content.match(regexp);
      return match && match[0];
    },
  },
  mounted() {
    if (this.$route.query.focus === 'contacts' && this.$refs.modal) {
      this.$refs.modal.open();
    }
  },
};
</script>

<style lang="scss" scoped>
.event-contacts-card {
  text-align: center;

  ::v-deep .user-avatar {
    margin: 0 auto 1rem;

    &__svg {
      display: none;
    }

    &__img {
      background-size: 80%;
    }
  }

  &__phone {
    margin-bottom: 0.75rem;
  }

  &__button {
    margin-top: 1.5rem;
  }
}
</style>
